import UrlGeneration from "../libs/UrlGeneration";
// import { debounce } from 'throttle-debounce';
import popup from "./popup";
import dropdownInput from "./dropdown-input";

export default new (class Filter {
    constructor() {
        this.wraperFilter = 'filter';
        this.preloaderClass = 'filter_preloader';

        this.accordionFilter = 'filter-accordion';
        this.accordionBtnFilter = 'filter-accordion-btn';
        this.accordionContentFilter = 'filter-accordion-content';
        this.accordionItemFilter = 'filter-accordion-item';
        this.accordionCountFilter = 'filter-accordion-count';
        this.sHandler = null;
        this.applyDebounce = () => {
            UrlGeneration.remove('page');
            UrlGeneration.update();
            this.apply();
        };
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {

            if(document.querySelector(`.${this.accordionCountFilter}`)) {
                this.getCountVisibleFilterItem()
            }

             /* аккардион для открытия всего фильтра */
            document.querySelectorAll(`.${this.accordionBtnFilter}`).forEach((accordionBtn) => {
                accordionBtn.addEventListener('click', (e) => {
                    document.querySelector(`.${this.accordionFilter}`).classList.toggle('open')
                    if(document.querySelector(`.${this.accordionFilter}`).classList.contains('open')) {
                        document.querySelector(`.${this.accordionContentFilter}`).style.height = document.querySelector(`.${this.accordionContentFilter}`).scrollHeight + 'px';
                    }
                    else {
                        document.querySelector(`.${this.accordionContentFilter}`).removeAttribute('style')
                    }
                });
            });

            document.body.addEventListener('change', (e) => this.onChange(e))
        })
        window.addEventListener("resize", () => {
            if(document.querySelector(`.${this.accordionCountFilter}`)) {
                this.getCountVisibleFilterItem()
            }
        });

        document.body.addEventListener('click', (e) => {
            if (e.target.closest('.filter-popup .filter-set-btn')) {
                this.onPopupSubmit();
            }

            if (e.target.closest('.filter-popup .filter-reset, .filter-catalog-reset-btn')) {
                this.onPopupReset();
            }

            if (e.target.closest('.filter-catalog [type="radio"]:checked + label, .filter-popup-catalog [type="radio"]:checked + label')) {
                setTimeout(() => {
                    const label = e.target.closest('label');
                    const input = document.getElementById(label.htmlFor);
                    const event = new Event('change', {
                        bubbles: true,
                        cancelable: true,
                    })
                    input.checked = false;
                    input.dispatchEvent(event);
                }, 0);

            }
            
        })

        this.checkCategoryLabelsWidth();
    }

    checkCategoryLabelsWidth() {
        const labels = document.querySelectorAll('.filter-catalog .filter-category:not(.filter-subcategory) .filter-category-item');
        labels.forEach(label => {
            const labelText = label.querySelector('.filter-category-item__text');
            if (label.form.elements[label.htmlFor].checked) {
                labelText.style.setProperty('--category-label-width', labelText.scrollWidth + 'px');
            } else {
                labelText.style.setProperty('--category-label-width', 0 + 'px')
            }
        })
    }

    onChange(e) {
        const input = e.target;
        if (!input.closest('.filter')) return;

        if (input.type == 'checkbox' || input.type == 'radio') {
            if (input.closest('.filter-catalog')) {
                this.onChangeCatalog(input);

            } else if (input.closest('.filter-recipes')) {
                this.onChangeRecipe(input);
            } else if (input.closest('.filter-popup')) {
                this.updatePopup()
            } else {
                /* TODO: Сделал пока свой костыль */
                setTimeout(function() {
                    input.form.submit();
                }, 250);
            }
        }
    }

    onChangeCatalog(input) {
        requestAnimationFrame(() => this.checkCategoryLabelsWidth())
        if (input.checked) {
            if (input.type == "radio") {
                UrlGeneration.remove(input.name);
            }
            UrlGeneration.set(input.name, input.value);
        } else {
            UrlGeneration.removeValue(input.name, input.value);
        }

        if (input.name == 'filter[category][]') {
            // UrlGeneration.remove('filter[subcategory][]');

            this.onChangeCatalogCategory();
        }

        UrlGeneration.update();

        this.sHandler = input.closest(`.${this.wraperFilter}`).dataset.handler;

        this.apply = () => this.applyCatalog();

        this.applyDebounce();
    }

    onChangeRecipe(input) {
        if (!input.closest('.filter-popup')) {
            if (input.checked) {
                UrlGeneration.set(input.name, input.value);
            } else {
                UrlGeneration.removeValue(input.name, input.value);
            }
            UrlGeneration.update();

            [].forEach.call(input.form.elements, item => this.syncCheckboxes(item));

            this.sHandler = input.closest(`.${this.wraperFilter}`).dataset.handler;

            this.apply = () => this.applyRecipes()

            this.applyDebounce();
        }

    }

    onPopupSubmit() {
        const wrap = document.querySelector('.filter-popup');
        const checkboxes = wrap.querySelectorAll('[type="checkbox"], [type="radio"]');
        let bWithSubcategory = false;

        if (wrap.classList.contains('filter-popup-recipes')) {
            const query = wrap.querySelector('[name="query"]');
    
            document.querySelectorAll('.search-form:not(.search-form-main)').forEach(form => {
                form.elements['query'].setAttribute('value', query.value)
                form.elements['query'].value = query.value;
            });
    
            UrlGeneration.replace('query', query.value);
        } 

        
        checkboxes.forEach(item => {
            this.syncCheckboxes(item);
            
            if (item.checked) {
                if (!UrlGeneration.hasValue(item.name, item.value)) UrlGeneration.set(item.name, item.value);
                if (item.name == 'filter[subcategory][]') bWithSubcategory = true;
            } else {
                UrlGeneration.removeValue(item.name, item.value);
            }

            if (!bWithSubcategory) {
                UrlGeneration.remove('filter[subcategory][]');
            }
        });
        
        UrlGeneration.update();

        this.checkCategoryLabelsWidth();

        this.sHandler = document.querySelector('#filters').dataset.handler;

        this.apply = () => this.applyPopup(wrap, () => {
            popup.popupMenuClose();
        });

        this.applyDebounce();
    }

    syncCheckboxes(checkbox) {
        let sSelector = `[name="${checkbox.name}"][value="${checkbox.value}"]`;
        sSelector += !checkbox.checked ? ':checked' : '';
        document.querySelectorAll(sSelector).forEach(item => {
            item.checked = checkbox.checked;
        })
    }

    applyPopup(wrap, cb) {
        const _this = this;
        wrap.classList.add(this.preloaderClass);
        let update;
        if (wrap.classList.contains('filter-popup-recipes')) {
            update = {
                'recipes-page/filter': '#recipes-filter',
                'filter/filter-popup': '#filter-popup-content',
                'recipes-page/recipe-list': '#recipe-list',
                'recipes-page/showcases': '#showcases',
            }
        } else {
            update = {
                'catalog-page/product-list': '#product-list',
                'catalog-page/showcases': '#showcases',
                'catalog-page/filter': '#filter-catalog',
                'filter/filter-popup-catalog': '#filter-popup-catalog-content',
            }
        }

        this.checkCategoryLabelsWidth();
        oc.ajax(this.sHandler, {
            success: function(...data) {
                wrap.classList.remove(_this.preloaderClass);
                if (cb) cb();
                this.success(...data);
                _this.checkCategoryLabelsWidth();
            },
            update 
        });
    }

    updatePopup() {
        const oldData = JSON.stringify(UrlGeneration.obParamList);
        const popup = document.querySelector('.filter-popup');
        let update;

        UrlGeneration.clear();

        if (popup.classList.contains('filter-popup-recipes')) {
            UrlGeneration.set('query', popup.querySelector('input[name="query"]').value);
            update = {
                'filter/filter-popup': '#filter-popup-content',
            }
        } else {
            update = {
                'filter/filter-popup-catalog': '#filter-popup-catalog-content',
            }
        }
        popup.querySelectorAll(':checked').forEach(item => {
            UrlGeneration.set(item.name, item.value);
        });
        UrlGeneration.update(true);

        popup.classList.add(this.preloaderClass);
        oc.ajax(document.querySelector('#filters').dataset.handler, {
            complete: () => {
                popup.classList.remove(this.preloaderClass);
                dropdownInput.updateAll();
            },
            update
        });
        UrlGeneration.obParamList = JSON.parse(oldData);
        UrlGeneration.update(true)

    }

    applyCatalog() {
        const _this = this;
        const wrap = document.querySelector(`.${this.wraperFilter}`);
        wrap.classList.add(this.preloaderClass);
        oc.ajax(this.sHandler, {
            success: function(...data) {
                wrap.classList.remove(_this.preloaderClass);
                this.success(...data);
                _this.checkCategoryLabelsWidth()
            },
            update: {
                'catalog-page/product-list': '#product-list',
                'catalog-page/showcases': '#showcases',
                'catalog-page/filter': '#filter-catalog',
                'filter/filter-popup-catalog': '#filter-popup-catalog-content',
            }
        });
    }

    applyRecipes() {
        const _this = this;
        const wrap = document.querySelector(`.${this.wraperFilter}`);
        wrap.classList.add(this.preloaderClass);

        document.querySelectorAll('.filter-popup [type="checkbox"], .filter-popup [type="radio"]').forEach((input) => {
            UrlGeneration.remove(input.name);
        });
        oc.ajax(this.sHandler, {
            success: function(...data) {
                wrap.classList.remove(_this.preloaderClass);
                this.success(...data);
                document.querySelectorAll('.filter-popup [type="checkbox"], .filter-popup [type="radio"]').forEach((input) => {
                    if (input.checked) {
                        UrlGeneration.set(input.name, input.value);
                    }
                });

                UrlGeneration.update();
                
            },
            update: {
                'recipes-page/filter': '#recipes-filter',
                'filter/filter-popup': '#filter-popup-content',
                'recipes-page/recipe-list': '#recipe-list',
                'recipes-page/showcases': '#showcases',
            }
        });
    }

    onPopupReset() {
        const wrap = document.querySelector('.filter-popup');
        const checkboxes = wrap.querySelectorAll('[type="checkbox"], [type="radio"]');
        checkboxes.forEach(item => {
            item.checked = false;
            this.syncCheckboxes(item);
            UrlGeneration.removeValue(item.name, item.value);
        });
        UrlGeneration.update();
        dropdownInput.updateAll();
        
        this.checkCategoryLabelsWidth()

        this.bFiltered = false;
        this.sHandler = document.querySelector('#filters').dataset.handler;

        const filterWrap = document.querySelector(`.${this.wraperFilter}`);
        filterWrap.classList.add(this.preloaderClass);

        this.apply = () => this.applyPopup(wrap, () => {
            filterWrap.classList.remove(this.preloaderClass);
        });

        this.applyDebounce();
    }

    onChangeCatalogCategory() {
        const wrap = document.querySelector('.filter-popup');
        const checkboxes = wrap.querySelectorAll('[type="checkbox"], [type="radio"]');
        checkboxes.forEach(item => {
            if (item.name != 'filter[category][]') {
                item.checked = false;
                this.syncCheckboxes(item);
                UrlGeneration.removeValue(item.name, item.value);
            }
        });
    }

    /**
     * @description Высчитывание кол-во видимых фильтов в аккардионе
     */
    getCountVisibleFilterItem() {
        //let count = 0;
        /*let _this = this;

        // Создаем новый observer (наблюдатель)
        let observer = new IntersectionObserver(function (entries, obs) {
            let count = 0;
            entries.forEach(function (entry) {
                if(entry.isIntersecting === false) {
                    count = count + 1
                    obs.unobserve(entry.target);
                }
            });
            if(!document.querySelector(`.${_this.accordionCountFilter}`).closest('.open')) {
                document.querySelector(`.${_this.accordionCountFilter}`).textContent = count
            }
            return count
        });

        document.querySelectorAll(`.${this.accordionItemFilter}`).forEach((accordionItem) => {
            observer.observe(accordionItem);
        })*/
        let count = 0;
        let widthParent = document.querySelector(`.${this.accordionContentFilter}`).offsetWidth;
        let widthChild = 0;

        document.querySelectorAll(`.${this.accordionItemFilter}`).forEach((accordionItem) => {
            widthChild = widthChild + accordionItem.offsetWidth
            if(widthChild > widthParent) {
                count = count + 1
                console.log(widthChild);
            }
        })

        if(count == 0) {
            document.querySelector(`.${this.accordionBtnFilter}`).classList.add('disable')
        }
        else {
            document.querySelector(`.${this.accordionBtnFilter}`).classList.remove('disable')
        }
        document.querySelector(`.${this.accordionCountFilter}`).textContent = count
    }
})()
